import _ from 'lodash'

import { getSpecificAttrValue } from 'utils'
import { produceCheckOptions } from 'utils/filter'
import { convertFundRange } from '../data.format'

const filter = {
  extraClasses: '',
  common: {
    terms: {
      expand: '#{fundList.filter.expand}',
      shrink: '#{fundList.filter.shrink}',
      placeholderSelected: '#{fundList.filter.placeholderSelected}',
      placeholderUnselected: '#{fundList.filter.placeholderUnselected}'
    }
  },
  blocks: [
    {
      extraClasses: 'align-middle',
      elements: [
        {
          extraClasses: 'large-6 xlarge-5',
          type: 'input',
          label: '#{fundList.filter.search.label}',
          placeholder: '#{fundList.filter.search.placeholder}',
          reducerId: 'dividend_filter_input',
          key: 'fundName[0].name||fundName[1].name||groups[x].isin||groups[x].taCode',
          wholeMatchKeys: ['groups[x].taCode'],
          value: '',
          splittingWords: []
        },
        {
          extraClasses: 'large-6 show-for-large',
          type: 'check',
          label: '#{fundList.filter.fundType}',
          key: '$fundRangeCode',
          options: (fundItems) => produceCheckOptions(fundItems, '$fundRangeCode', ['境內基金', '境外基金'], 'show-for-large'),
          value: []
        },
        {
          extraClasses: 'large-6 hide-for-large',
          type: 'check',
          label: '#{fundList.filter.fundType}',
          key: '$fundRangeCodeShort',
          options: (fundItems) => produceCheckOptions(fundItems, '$fundRangeCodeShort', ['境內', '境外'], 'hide-for-large'),
          value: []
        }
      ]
    }
  ],
  delegation: {
    $fundRangeCodeShort: {
      lead: {
        key: '$fundRangeCode',
        map: {
          境內: '境內基金',
          境外: '境外基金'
        }
      }
    },
    $fundRangeCode: {
      delegated: {
        key: '$fundRangeCodeShort',
        map: {
          境內基金: '境內',
          境外基金: '境外'
        }
      }
    }
  },
  twiceReducers: [
    {
      id: 'dividend_filter_input',
      type: 'input',
      path: 'groups',
      key: 'isin||taCode',
      wholeMatchKeys: ['taCode']
    }
  ]
}

const map = [
  // onshore offshore
  (fundItem, _rule, terms) => {
    return convertFundRange(fundItem, _rule, terms)
  },
  (fundItem) => {
    const sortedGroups = fundItem.groups.sort((a, b) => {
      const aShareclassNote = getSpecificAttrValue({ originData: a.shareclassNote, attrValue: 'zh-TW', valuePlaceholder: '' })
      const bShareclassNote = getSpecificAttrValue({ originData: b.shareclassNote, attrValue: 'zh-TW', valuePlaceholder: '' })
      return bShareclassNote.length - aShareclassNote.length
    })

    const longestShareclassNote = !_.isEmpty(sortedGroups)
      ? getSpecificAttrValue({
          originData: _.first(sortedGroups).shareclassNote,
          attrValue: 'zh-TW',
          valuePlaceholder: ''
        })
      : ''

    return { ...fundItem, shareclassNote: longestShareclassNote }
  }
]

export default { filter, map }
